// /* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
/* Importing Help, InsuranceDetails, InsuranceForm, Login, Register and UpdateProfile
 components before adding them into the router object */
import Help from '../components/Help'
import InsuranceDetails from '../components/InsuranceDetails'
import InsuranceForm from '../components/InsuranceForm'
import Login from '../components/Login'
import Register from '../components/Register'
import UpdateProfile from '../components/UpdateProfile'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/login', name: 'Login', component: Login },
    { path: '/register', name: 'Register', component: Register },
    { path: '/help', name: 'Help', component: Help },
    { path: '/',
      name: 'InsuranceForm',
      component: InsuranceForm,
      beforeEnter (to, from, next) {
        store.dispatch('autoLogin')
          .then(() => {
            localStorage.getItem('token') ? console.log('Log in automatically with success !')
              : console.log('Failed to log in automatically !')
          })
        store.state.token ? next() : next('/login')
      }
    },
    { path: '/insurancedetails',
      name: 'InsuranceDetails',
      component: InsuranceDetails,
      beforeEnter (to, from, next) {
        store.dispatch('autoLogin')
          .then(() => {
            localStorage.getItem('token') ? console.log('Log in automatically with success !')
              : console.log('Failed to log in automatically !')
          })
        store.state.token ? next() : next('/login')
      }
    },
    { path: '/updateprofile',
      name: 'UpdateProfile',
      component: UpdateProfile,
      beforeEnter (to, from, next) {
        store.dispatch('autoLogin')
          .then(() => {
            localStorage.getItem('token') ? console.log('Log in automatically with success !')
              : console.log('Failed to log in automatically !')
          })

        store.state.token ? next() : next('/login')
      }
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js